// routes
import { ToastContainer } from 'react-toastify';
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
import { BaseOptionChartStyle } from './components/chart/BaseOptionChart';
import 'react-toastify/dist/ReactToastify.css';
import ConfirmDialog from './components/ConfirmDialog';
import ConfirmDialogProvider from './context/ConfirmDialogContext';
import AuthProvider from './context/AuthContext';
import SettingsProvider from './context/SettingsContext';
import AppCss from './App.css';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <ThemeProvider>
          <ConfirmDialogProvider>
            <ScrollToTop />
            <BaseOptionChartStyle />
            <Router />
            <ToastContainer />
            <ConfirmDialog />
          </ConfirmDialogProvider>
        </ThemeProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}
